import { useColorScheme } from './use-color-scheme';

export function useUnifiedColorScheme() {
  return useColorScheme();
}
